module.exports = __webpack_public_path__ + "static/img/phone-01-copy-9.725fe97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tip/phone-01-copy-9.png
// module id = Zhco
// module chunks = 1